interface TransitionOverlayProps {
  isVisible: boolean;
  message?: string;
}

export const TransitionOverlay = ({ 
  isVisible, 
  message = "Regresando al inicio..." 
}: TransitionOverlayProps) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-white z-[100] flex items-center justify-center animate-fade-in">
      <div className="text-center">
        {/* Loader sutil */}
        <div className="w-12 h-12 border-3 border-[#FF6A2A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        
        {/* Mensaje */}
        <p className="text-base font-semibold text-[#111827]">{message}</p>
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 0.2s ease-out;
        }
      `}</style>
    </div>
  );
};
